module.exports = __webpack_public_path__ + "img/topic-bg.be51baa7.png";